import { Flex, TypographyProps } from "@aircall/tractor";

import { SpeakerName } from "./Title.styled";

import { SimpleSpeakerAvatar } from "@/components/SpeakerAvatar/SpeakerAvatar";
import { SpeakerAvatarVariant } from "@/states/call/speakers/speakers.utility.decl";

interface MainAgentHeadingProps {
  color: TypographyProps["color"];
  variant: SpeakerAvatarVariant;
  fullName?: string | null;
}

export function MainAgentHeading({
  color,
  variant,
  fullName,
}: MainAgentHeadingProps) {
  return (
    <Flex gap="xxxs">
      <SimpleSpeakerAvatar variant={variant} name={fullName} />
      <SpeakerName color={color}>{fullName}</SpeakerName>
    </Flex>
  );
}
